
import { layout } from '@/mixins/customLayout'
import { RichContent } from '@/modules/RichContent'
export default {
  name: 'Picture',
  components: {},
  mixins: [layout],
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      containerWidth: null
    }
  },
  computed: {
    img() {
      const url = (this.blok.image.filename || '').replace(
        'https://a.storyblok.com',
        ''
      )
      // get width and height from URL
      const [, width, height] = (url.match(/(\d+)x(\d+)/) || []).map(x =>
        parseFloat(x)
      )
      // calculate at what width to request the image
      const widths = [this.containerWidth, this.blok.max_width, width]
      const minWidth = Math.min(...widths.filter(Boolean))
      // calculate inline styles
      const inlineStyles = {}
      if (this.blok.max_width) {
        inlineStyles['max-width'] = `${this.blok.max_width}px`
        inlineStyles['max-height'] = `${(this.blok.max_width * height) /
          width}px`
      }
      inlineStyles.transform =
        this.blok.rotate > 0 ? `rotateZ(${this.blok.rotate}deg)` : ''

      return {
        baseWidth: width,
        baseHeight: height,
        ratio: width / height,
        src: `${url}/m/${minWidth}x0`,
        srcset: `${url}/m/${minWidth}x0 1x, ${url}/m/${minWidth * 2}x0 2x`,
        style: inlineStyles
      }
    },
    computedLayout() {
      return this.constructClassObj(this.blok.custom_layout, this)
    },
    richContent() {
      return RichContent(this.blok.caption.content, {
        customer: this.$store.getters.customer(),
        pricing: this.$store.getters.pricing(this.productId)
      })
    }
  },
  mounted() {
    this.containerWidth = this.$refs.img.parentNode.offsetWidth
  }
}
